module.exports = __webpack_public_path__ + "media/images/svg/clients/1-4652d58f29237bbeb836eed80c610103.svg";